import { render, staticRenderFns } from "./MatriculasPorUnidade.vue?vue&type=template&id=722dfa40&scoped=true"
import script from "./MatriculasPorUnidade.vue?vue&type=script&lang=js"
export * from "./MatriculasPorUnidade.vue?vue&type=script&lang=js"
import style0 from "./MatriculasPorUnidade.vue?vue&type=style&index=0&id=722dfa40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722dfa40",
  null
  
)

export default component.exports